// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__15Lpm","title":"InfoRow_title__1Dtxp"};